import React from "react";
import { InputAdornment, TextField } from "@mui/material";

const EditableInput = ({
  field,
  label,
  unit = null,
  isReadOnly = false,
  value,
  targetWeightUnit,
  errors = {},
  isAdviceLoading = false,
  onChange,
  onWeightUnitChange,
  t,
  disabled = false,
}) => {
  return (
    <div className="w-full">
      <span className="text-[#414651] text-[14px] sm:text-[16px] block mb-1">
        {label}
      </span>

      {field === "targetWeight" ? (
        <div className="relative">
          <TextField
            type="number"
            variant="outlined"
            fullWidth
            size="small"
            value={
              value === null || value === undefined || value === ""
                ? ""
                : Math.round(Number(value))
            }
            onChange={(e) => onChange(field, e.target.value)}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
            }}
            disabled={isAdviceLoading || isReadOnly || disabled}
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "0.875rem",
                color: "black",
                height: "40px",

                "& fieldset": {
                  borderRadius: "0.375rem",
                  borderColor: "#D1D5DB", // default border color
                },

                "&:hover fieldset": {
                  borderColor: "#D1D5DB", // SAME as normal → no black border
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#0575e6", // or same color if you want no focus change
                  borderWidth: 1,
                },
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <div className="flex items-center mr-1">
                    {["kg", "Lbs"].map((u) => (
                      <button
                        key={u}
                        onClick={() => onWeightUnitChange(u)}
                        className={`px-2 py-0.5 border rounded-md mx-0.5 text-xs ${
                          targetWeightUnit === u
                            ? "bg-blue-500 text-white"
                            : "bg-white text-black border-gray-300"
                        }`}
                        type="button"
                        disabled={isAdviceLoading}
                      >
                        {u}
                      </button>
                    ))}
                  </div>
                </InputAdornment>
              ),
            }}
          />
        </div>
      ) : (
        <input
          type="number"
          min="1"
          className={`w-full border p-2 rounded-md h-10 text-sm focus:outline-none ${
            errors[field] ? "border-red-500 text-red-500" : "text-black"
          }`}
          value={
            value === null || value === undefined || value === ""
              ? ""
              : Math.round(Number(value))
          }
          onChange={(e) => onChange(field, e.target.value)}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          placeholder={label}
          disabled={isAdviceLoading || isReadOnly}
        />
      )}

      {errors[field] && (
        <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
          {t ? t("preferences.validation.fieldRequired", { field: label }) : ""}
        </div>
      )}
    </div>
  );
};

export default EditableInput;
